import initialState from './initialState'

import {
  ONLINE,
  OFFLINE,
  STATUS_MESSAGE,
  SET_DARK_MODE,
  OPEN_DEVICE_SYNC,
  OPEN_PREFERENCES,
  SET_PREFERENCE_TOOLTIPS,
  SET_MIDI_THRU,
  REFRESH_THRU_PORTS
} from '../actions/actionTypes'

export default function editorReducer(state = initialState.editor, action) {
  switch (action.type) {
    case ONLINE:
      return { ...state, networkConnection: true }

    case OFFLINE:
      return { ...state, networkConnection: false }

    case STATUS_MESSAGE:
      return { ...state, status: action.status }

    case SET_DARK_MODE:
      return { ...state, isDarkMode: action.isDarkMode }

    case OPEN_DEVICE_SYNC:
      return { ...state, deviceSyncOpen: action.status }

    case OPEN_PREFERENCES:
      return { ...state, preferencesOpen: action.status }

    case SET_PREFERENCE_TOOLTIPS:
      return { ...state, showTooltips: action.status }

    case SET_MIDI_THRU:
      return { ...state, midithruport: action.portname }

    case REFRESH_THRU_PORTS:
      return { ...state, midithruport: "none" }

    default:
      return state
  }
}
